import React from "react"
import Layout from '../components/layout'
import { Helmet } from "react-helmet"




class Index extends React.Component {
    render() {
        return (
            <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="Description" content="BankInvoice service page" />
                <title>Bank Invoice</title>
                </Helmet>
            </Layout>
        )
    }
}
export default Index

